/**
 * Display helpers shared by the statement-import list and its detail modal.
 *
 * Extracted statement dates are plain `YYYY-MM-DD` strings, so they are
 * rendered in UTC to avoid shifting a day in negative-offset timezones.
 */

export const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
};

export const formatCard = (cardAccount) => {
  if (!cardAccount) return '—';
  return [cardAccount.label, cardAccount.masked_number].filter(Boolean).join(' · ') || '—';
};

export const formatPeriod = (statement) => {
  if (!statement?.period_start && !statement?.period_end) return '—';
  return [formatDate(statement.period_start), formatDate(statement.period_end)].filter(Boolean).join(' – ');
};

export const hasDisplayValue = (value) => value !== null && value !== undefined && value !== '';

const MONTH_KEYS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

/**
 * Labels the generated XPENS statement a matched transaction belongs to.
 *
 * Generated statements carry a one-based `period` month and a `year`; older
 * ones may only have the date range, so that is used as the fallback.
 *
 * @param {object|null} xpensStatement - The `match.xpens_statement` projection.
 * @param {object} t - The translator from the MobX data store.
 * @returns {string} A human-readable period, or '' when none is known.
 */
export const formatXpensPeriod = (xpensStatement, t) => {
  if (!xpensStatement) return '';

  const monthKey = MONTH_KEYS[xpensStatement.period - 1];
  const monthLabel = monthKey && t ? t.read(`month.${monthKey}`) : monthKey;
  const label = [monthLabel, xpensStatement.year].filter(hasDisplayValue).join(' ');
  if (label) return label;

  if (!xpensStatement.start_date && !xpensStatement.end_date) return '';
  return formatPeriod({
    period_start: xpensStatement.start_date,
    period_end: xpensStatement.end_date,
  });
};
